import { useCallback } from 'react'

import { crmEngine } from '@/services/crm'
import { useOpportunityStore } from '@/stores/opportunity-store'

export function useReminder() {
  const reminders = useOpportunityStore((s) => s.reminders)
  const refresh = useOpportunityStore((s) => s.refresh)

  const sync = useCallback(() => {
    const generated = crmEngine.reminders()
    refresh()
    return generated
  }, [refresh])

  const dismiss = useCallback(
    (id: string) => {
      const next = crmEngine.dismissReminder(id)
      refresh()
      return next
    },
    [refresh],
  )

  const urgent = reminders.filter((r) => r.level === 'urgent')
  const warning = reminders.filter((r) => r.level === 'warning')
  const info = reminders.filter((r) => r.level === 'info')

  return {
    reminders,
    urgent,
    warning,
    info,
    sync,
    dismiss,
  }
}
